import { TileDefinition, TileLayout } from "../../../types/dashboard";

export function getScaledStyles(
  tile: any,
  availableW: number,
  availableH: number
) {
  const type = String(tile?.chart_type ?? '').toLowerCase();
  const noScaleTypes = new Set(['metric_chart', 'metricchart', 'datagrid', 'line_chart', 'bar_chart']);

  const viewportBase = {
    width: '100%',
    height: '100%',
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden' as const,
    position: 'relative' as const,
    display: 'flex',
  };

  const canvasNoScale = {
    width: '100%',
    height: '100%',
    minWidth: 0,
    minHeight: 0,
    transform: 'none',
    transformOrigin: 'top left' as const,
  };

  if (noScaleTypes.has(type)) {
    return { viewportStyle: viewportBase, canvasStyle: canvasNoScale };
  }

  const boundaryW = Number(tile?.settings?.boundarySize?.width);
  const boundaryH = Number(tile?.settings?.boundarySize?.height);

  if (!Number.isFinite(boundaryW) || boundaryW <= 0 || !Number.isFinite(boundaryH) || boundaryH <= 0) {
    return { viewportStyle: viewportBase, canvasStyle: canvasNoScale };
  }

  if (!(availableW > 0) || !(availableH > 0)) {
    return { viewportStyle: viewportBase, canvasStyle: canvasNoScale };
  }

  const scale = Math.min(availableW / boundaryW, availableH / boundaryH);
  const scaledW = boundaryW * scale;
  const scaledH = boundaryH * scale;

  const offsetX = Math.max(0, (availableW - scaledW) / 2);
  const offsetY = Math.max(0, (availableH - scaledH) / 2);

  return {
    viewportStyle: viewportBase,
    canvasStyle: {
      width: `${boundaryW}px`,
      height: `${boundaryH}px`,
      minWidth: `${boundaryW}px`,
      minHeight: `${boundaryH}px`,
      maxWidth: `${boundaryW}px`,
      maxHeight: `${boundaryH}px`,
      transform: `translate(${offsetX}px, ${offsetY}px) scale(${scale})`,
      transformOrigin: 'top left' as const,
      willChange: 'transform',
    },
  };
}

export const updateTileLayout = (original: TileDefinition, layout: any) => {
  const prev = original.layout || {} as TileLayout;
    const next = {
      ...prev,
      x: Math.max(0, Number(layout.x)),
      y: Math.max(0, Number(layout.y)),
      w: Math.max(1, Math.min(8, Number(layout.w))),
      h: Math.max(1, Number(layout.h)),
      i: String(layout.i),
    };
    if (
      prev.x !== next.x ||
      prev.y !== next.y ||
      prev.w !== next.w ||
      prev.h !== next.h
    ) {
      return { tile: { ...original, layout: next }, updated: true };
    }
    return { tile: original, updated: false };
  }